function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 12",
    style: {
      enableBackground: "new 0 0 24 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M23.029,2.837c0.358,0,0.65,0.292,0.65,0.65v5.166c0,0.358-0.292,0.65-0.65,0.65H0.971 c-0.358,0-0.65-0.292-0.65-0.65V3.487c0-0.358,0.292-0.65,0.65-0.65H23.029 M23.029,2.515H0.971C0.437,2.515,0,2.952,0,3.487v5.166 c0,0.534,0.437,0.971,0.971,0.971h22.057C23.563,9.624,24,9.187,24,8.653V3.487C24,2.952,23.563,2.515,23.029,2.515L23.029,2.515z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M9.551,6.602H8.482v0.317H9.24 C9.203,7.364,8.833,7.554,8.483,7.554c-0.447,0-0.837-0.352-0.837-0.845c0-0.48,0.372-0.85,0.838-0.85 c0.36,0,0.572,0.229,0.572,0.229l0.222-0.23c0,0-0.285-0.317-0.805-0.317c-0.662,0-1.174,0.559-1.174,1.162 c0,0.592,0.482,1.168,1.191,1.168c0.624,0,1.081-0.427,1.081-1.06C9.571,6.679,9.551,6.602,9.551,6.602L9.551,6.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M10.464,6.666c0.216,0,0.42,0.174,0.42,0.455 c0,0.275-0.204,0.454-0.421,0.454c-0.239,0-0.428-0.191-0.428-0.457C10.036,6.86,10.222,6.666,10.464,6.666L10.464,6.666 L10.464,6.666z M10.46,6.372c-0.439,0-0.753,0.343-0.753,0.743c0,0.406,0.305,0.755,0.758,0.755c0.41,0,0.747-0.314,0.747-0.747 C11.212,6.628,10.821,6.372,10.46,6.372L10.46,6.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M12.12,6.666c0.216,0,0.42,0.174,0.42,0.455 c0,0.275-0.204,0.454-0.421,0.454c-0.239,0-0.428-0.191-0.428-0.457C11.691,6.86,11.878,6.666,12.12,6.666L12.12,6.666 L12.12,6.666z M12.116,6.372c-0.439,0-0.753,0.343-0.753,0.743c0,0.406,0.305,0.755,0.758,0.755c0.41,0,0.747-0.314,0.747-0.747 C12.867,6.628,12.476,6.372,12.116,6.372L12.116,6.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M13.767,6.667c0.197,0,0.4,0.169,0.4,0.456 c0,0.293-0.202,0.454-0.405,0.454c-0.215,0-0.414-0.174-0.414-0.451C13.348,6.838,13.555,6.667,13.767,6.667L13.767,6.667 L13.767,6.667z M13.737,6.373c-0.403,0-0.719,0.353-0.719,0.749c0,0.451,0.367,0.75,0.712,0.75c0.214,0,0.327-0.085,0.411-0.182 v0.148c0,0.258-0.157,0.413-0.394,0.413c-0.229,0-0.344-0.17-0.383-0.267l-0.288,0.12c0.102,0.216,0.308,0.441,0.674,0.441 c0.4,0,0.706-0.252,0.706-0.781V6.418h-0.314v0.127C14.045,6.441,13.913,6.373,13.737,6.373L13.737,6.373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M15.931,6.659c0.137,0,0.235,0.073,0.277,0.16L15.537,7.1 C15.509,6.883,15.714,6.659,15.931,6.659L15.931,6.659L15.931,6.659z M15.918,6.371c-0.38,0-0.699,0.302-0.699,0.748 c0,0.472,0.355,0.752,0.735,0.752c0.317,0,0.511-0.173,0.628-0.329L16.323,7.37c-0.067,0.104-0.18,0.206-0.367,0.206 c-0.211,0-0.307-0.115-0.367-0.227l1.004-0.417L16.541,6.81C16.444,6.571,16.218,6.371,15.918,6.371L15.918,6.371z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.707,
    y: 5.618,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    width: 0.33,
    height: 2.208
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.007,
    y: 5.618,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    width: 0.33,
    height: 2.208
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M18.105,5.618h-0.468h-0.33v1.407v0.801h0.33V7.025h0.468 c0.387,0,0.703-0.317,0.703-0.703C18.809,5.935,18.492,5.618,18.105,5.618z M18.105,6.695h-0.468V5.948h0.468 c0.205,0,0.373,0.169,0.373,0.373C18.479,6.527,18.31,6.695,18.105,6.695z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    points: "22.047,6.371 21.614,7.355 21.182,6.371  20.822,6.371 21.434,7.765 21.091,8.545 21.452,8.545 22.407,6.371  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M20.523,7.828h0.315V7.07 c0.049-0.782-0.943-0.966-1.318-0.402l0.254,0.17c0.184-0.321,0.707-0.247,0.742,0.097c-0.157-0.042-0.327-0.072-0.483-0.056 c-0.242,0.025-0.45,0.179-0.483,0.431c-0.018,0.136,0.013,0.304,0.108,0.407c0.148,0.16,0.392,0.181,0.592,0.127 c0.113-0.031,0.201-0.098,0.274-0.184V7.828L20.523,7.828z M20.523,7.219c-0.04,0.175-0.176,0.302-0.349,0.349 c-0.364,0.099-0.455-0.493,0.086-0.411C20.354,7.167,20.435,7.19,20.523,7.219z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M7.9,3.786C7.837,3.764,7.751,3.754,7.644,3.754H7.411v1.082h0.23c0.108,0,0.194-0.01,0.253-0.03 c0.064-0.02,0.126-0.056,0.184-0.107C8.193,4.596,8.252,4.46,8.252,4.295c0-0.165-0.056-0.3-0.168-0.402 C8.029,3.843,7.967,3.807,7.9,3.786z M7.653,4.666H7.59V3.923h0.063c0.134,0,0.236,0.032,0.304,0.095 c0.076,0.07,0.114,0.164,0.114,0.277c0,0.112-0.039,0.205-0.115,0.275C7.919,4.603,7.876,4.628,7.83,4.644 C7.783,4.659,7.724,4.666,7.653,4.666z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.435,
    y: 3.754,
    style: {},
    width: 0.179,
    height: 1.082
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M9.244,4.186L9.138,4.142c-0.073-0.03-0.11-0.069-0.11-0.117c0-0.035,0.013-0.063,0.041-0.087 c0.028-0.024,0.063-0.036,0.105-0.036c0.034,0,0.063,0.007,0.084,0.021C9.278,3.936,9.3,3.963,9.324,4.003l0.005,0.008 l0.146-0.087L9.47,3.917C9.4,3.795,9.3,3.733,9.175,3.733c-0.093,0-0.172,0.028-0.234,0.084C8.878,3.872,8.846,3.942,8.846,4.024 c0,0.122,0.075,0.216,0.224,0.279l0.103,0.043C9.198,4.356,9.221,4.368,9.24,4.381c0.018,0.012,0.034,0.025,0.045,0.039 c0.011,0.014,0.02,0.028,0.025,0.045C9.316,4.48,9.318,4.498,9.318,4.518c0,0.049-0.016,0.089-0.047,0.121 C9.24,4.67,9.201,4.686,9.153,4.686c-0.061,0-0.106-0.021-0.137-0.065c-0.017-0.022-0.03-0.064-0.037-0.125l-0.001-0.01 l-0.181,0.04l0.001,0.009c0.015,0.101,0.053,0.18,0.114,0.236c0.062,0.056,0.141,0.084,0.235,0.084 c0.099,0,0.184-0.033,0.251-0.099c0.067-0.065,0.101-0.149,0.101-0.249c0-0.075-0.021-0.139-0.062-0.191 C9.396,4.265,9.331,4.221,9.244,4.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M10.069,3.773C10.023,3.76,9.954,3.754,9.865,3.754H9.674v1.082h0.179V4.404h0.065 c0.112,0,0.203-0.03,0.27-0.088c0.067-0.059,0.101-0.139,0.101-0.238c0-0.093-0.032-0.171-0.094-0.233 C10.159,3.81,10.116,3.785,10.069,3.773z M10.115,4.076c0,0.108-0.069,0.161-0.212,0.161H9.853V3.92h0.044 C10.044,3.92,10.115,3.971,10.115,4.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M10.95,3.734c-0.155,0-0.29,0.055-0.4,0.164c-0.111,0.109-0.167,0.241-0.167,0.392 c0,0.172,0.062,0.314,0.184,0.42c0.111,0.096,0.237,0.145,0.376,0.145c0.157,0,0.293-0.055,0.404-0.163 c0.111-0.108,0.167-0.241,0.167-0.396c0-0.154-0.056-0.287-0.166-0.397C11.237,3.789,11.104,3.734,10.95,3.734z M10.944,4.686 c-0.1,0-0.189-0.037-0.266-0.111c-0.077-0.074-0.116-0.169-0.116-0.283c0-0.109,0.038-0.202,0.112-0.276 c0.074-0.075,0.166-0.113,0.274-0.113c0.108,0,0.2,0.038,0.273,0.113c0.074,0.075,0.111,0.168,0.111,0.279 c0,0.109-0.038,0.203-0.112,0.279C11.145,4.648,11.053,4.686,10.944,4.686z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.887,
    y: 3.754,
    style: {},
    width: 0.179,
    height: 1.082
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M13.778,4.251c0.053-0.053,0.08-0.116,0.08-0.19c0-0.043-0.009-0.086-0.028-0.128 c-0.018-0.041-0.043-0.077-0.073-0.105c-0.03-0.027-0.068-0.046-0.112-0.058c-0.043-0.011-0.101-0.017-0.172-0.017h-0.169v1.082 h0.252c0.073,0,0.135-0.007,0.184-0.02c0.045-0.014,0.087-0.04,0.123-0.076c0.06-0.059,0.091-0.132,0.091-0.217 c0-0.065-0.017-0.123-0.051-0.172C13.871,4.305,13.829,4.271,13.778,4.251z M13.648,4.173C13.622,4.198,13.58,4.21,13.523,4.21 h-0.041V3.92h0.047c0.052,0,0.091,0.012,0.118,0.036c0.026,0.024,0.04,0.06,0.04,0.107C13.687,4.112,13.674,4.149,13.648,4.173z  M13.482,4.363h0.072c0.084,0,0.142,0.015,0.174,0.044c0.033,0.03,0.049,0.065,0.049,0.109c0,0.045-0.017,0.081-0.05,0.11 c-0.032,0.027-0.084,0.041-0.154,0.041h-0.09V4.363z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {},
    points: "14.316,3.754 14.137,3.754 14.137,4.836 14.629,4.836 14.629,4.666 14.316,4.666  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {},
    points: "14.763,4.836 15.368,4.836 15.368,4.666 14.942,4.666 14.942,4.329 15.356,4.329  15.356,4.16 14.942,4.16 14.942,3.923 15.368,3.923 15.368,3.754 14.763,3.754  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M16.445,3.754h-0.073l-0.504,1.082h0.193l0.118-0.258h0.443l0.112,0.258h0.196L16.445,3.754z  M16.255,4.408l0.151-0.33l0.144,0.33H16.255z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {},
    points: "12.651,4.836 12.651,3.754 12.472,3.754 12.472,4.479 11.778,3.754 11.696,3.754  11.696,4.836 11.875,4.836 11.875,4.105 12.575,4.836  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M1.879,3.854c-0.055,0.04-0.094,0.113-0.093,0.228 c0.001,0.259,0.019,3.713,0.02,3.93c0,0.093,0.023,0.168,0.066,0.215l2.201-2.19L1.879,3.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M4.179,5.932l0.633-0.63c-0.4-0.218-2.528-1.379-2.668-1.455 c-0.028-0.015-0.059-0.024-0.09-0.029L4.179,5.932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M5.846,5.866c-0.069-0.037-0.428-0.233-0.898-0.49 l-0.664,0.66l0.661,0.658c0.495-0.271,0.865-0.474,0.9-0.493C5.955,6.141,6.07,5.988,5.846,5.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M4.179,6.141L2.041,8.267c0.032-0.007,0.066-0.02,0.103-0.04 c0.14-0.077,1.619-0.886,2.665-1.459L4.179,6.141z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4739e306c0d0e929dde376c01bbf9d3b.svg";
export { ForwardRef as ReactComponent };